
import {Divider} from "antd";
import React from "react";

const SubSectionDivider = ({title}) => {
  return <Divider style={{marginTop:"0px", color: "darkgray"}}plain>{title}</Divider>;
};

export default SubSectionDivider;
